import ProjectPresetsListComponent from './presets-list.component'

export default ProjectPresetsListComponent
